import React from "react";
import { connect } from "react-redux";
import store from "../init/store.js";

import { convertSpeechArrayToTextLineArray } from "../text/convert-speech-array-to-textLine-array.js";
import OnboardingScreenTextLine from "./OnboardingScreenIntro";
import OnboardingScreenGetName from "./OnboardingScreenGetName";
import { loginFromOnboarding } from "./loginFromOnboarding";
import {
  goToHomeScreen,
  goToArenaFromInvite
} from "../b5-home/get-home-menu-options.js";
import { getQueryVariable } from "../helpers/get-query-variable.js";
import OnboardingLaptopContainer from "./OnboardingLaptop";
import OnboardingMemberRow from "./OnboardingMemberRow";
import AudioControl from '../_audio/AudioControl'
import OnboardingTransitionOverlay from './OnboardingTransitionOverlay'

class OnboardingScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: Boolean(store.getState().crew.logggedInUserId), //Use this if you want to add a "Welcome Back" screen.

      isOverlayOpaque: true,

      isLaptopLowered: false,
      step: "fade-out", //1. intro, intro2 2. getName, 3. outro
      nameFromUser: "" //"" //not known yet
    };
  }

  componentDidMount() {
    //First Step: fade out the overlay
    setTimeout(() => {
      this.setState({ isOverlayOpaque: false })
    }, 200)
  }

  //Intro overlay is done fading out, revealing our character and laptop
  handleOverlayDone() {
    setTimeout(() => {
      //Start the intro text
      this.setState({ step: "intro" })
    }, 200)
  }

  //Got the name, now move on to the next step in the chain.
  handleNameReceived(nameFromUserInput: "") {
    this.setState({
      step: "nice-to-meet-you",
      nameFromUser: nameFromUserInput
    });
  }

  handleTransitionToNextScreen() {
    loginFromOnboarding(this.state.nameFromUser, () => {
      //After the login is complete, go to homescreen.
      setTimeout(() => {
        if (this.props.isInvitedByFriend) {
          //Invited by friend: go straight to Arena
          goToArenaFromInvite();
        } else {
          //Visiting user
          goToHomeScreen();
        }
      }, 600);
    });
  }

  //Callback hell! Wait for a bit, then lower the laptop, then wait some more, and then exit to the Home screen
  exitLaptopScreen() {
    setTimeout(() => {
      this.setState(
        {
          isLaptopLowered: true
        },
        () => {
          setTimeout(() => {
            this.handleTransitionToNextScreen();
          }, 700);
        }
      );
    }, 600);
  }

  getIntroText() {
    if (this.props.isInvitedByFriend) {
      const friendName = getQueryVariable("f") || "A friend"; //EX: "Glenn" or "A friend"

      return [`${friendName} is challenging you to a `, "[FAST]Hack Battle!"];
    }

    return [
      "Hello!",
      "@@pause_300@@",
      "Welcome to The Danger Crew's ",
      "[FAST]BATTLE DEMO!",
      "@@pause_300@@",
      "I hope you're ready to do some hacking. "
    ];
  }

  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "40em",
      margin: "0 auto"
    };
  }

  setNextStep(nextStep, timeout = 1000) {
    setTimeout(() => {
      this.setState({ step: nextStep });
    }, timeout);
  }

  renderContent() {
    //Step one: INTRO
    if (this.state.step === "intro") {
      const introText = convertSpeechArrayToTextLineArray(
        this.getIntroText(), //Returns the proper array of text to use
        { defaultTextColor: "#fff" }
      );
      return (
        <OnboardingScreenTextLine
          key="1"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, "intro2")}
        />
      );
    }

    //Step one: INTRO
    if (this.state.step === "intro2" || this.state.step === "getName") {
      const introText = convertSpeechArrayToTextLineArray(
        ["We just need your name to get started..."],
        { defaultTextColor: "#fff" }
      );
      return (
        <OnboardingScreenTextLine
          key="2"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, "getName", 200)}
        />
      );
    }

    if (this.state.step === "nice-to-meet-you") {
      const introText = convertSpeechArrayToTextLineArray(
        [
          "Great! ",
          "@@pause_300@@",
          `Nice to meet you, ${this.state.nameFromUser}!`
        ],
        { defaultTextColor: "#fff" }
      );

      const nextStep = this.props.isInvitedByFriend
        ? "outro" //Skip to end if invite
        : "introduce-crew";

      return (
        <OnboardingScreenTextLine
          key="3"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, nextStep)}
        />
      );
    }

    if (this.state.step === "introduce-crew") {
      const introText = convertSpeechArrayToTextLineArray(
        [
          "This is your Crew.",
          "@@pause_300@@",
          "These friendly people will help you defeat rivals in the Hacker Battles to come."
        ],
        { defaultTextColor: "#fff" }
      );
      return (
        <OnboardingScreenTextLine
          key="4"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, "outro")}
        />
      );
    }

    if (this.state.step === "outro") {
      const endingLine = this.props.isInvitedByFriend
        ? "It's time to show your friend what you can do!" //Alternate copy for Invite link
        : "It's time to show the world what you can do!";

      const introText = convertSpeechArrayToTextLineArray(
        [
          "Grab your laptop and assemble for battle.",
          "@@pause_300",
          endingLine
        ],
        { defaultTextColor: "#fff" }
      );
      return (
        <OnboardingScreenTextLine
          key="5"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, "pre-laptop-delay")}
        />
      );
      //"Grab your laptops Are you ready to show the world what you can do?"
    }

    if (this.state.step === "pre-laptop-delay") {
      const introText = convertSpeechArrayToTextLineArray([""], {
        defaultTextColor: "#fff"
      });
      return (
        <OnboardingScreenTextLine
          key="6"
          text={introText}
          onTextComplete={this.setNextStep.bind(this, "laptops", 600)}
        />
      );
      //"Grab your laptops Are you ready to show the world what you can do?"
    }

    if (this.state.step === "laptops") {
      const introText = convertSpeechArrayToTextLineArray([""], {
        defaultTextColor: "#fff"
      });
      return (
        <OnboardingScreenTextLine
          key="7"
          text={introText}
          onTextComplete={this.exitLaptopScreen.bind(this)}
        />
      );
      //"Grab your laptops Are you ready to show the world what you can do?"
    }

    return null;
  }

  renderNameModal() {
    if (this.state.step === "getName") {
      // const getNameText = convertSpeechArrayToTextLineArray([
      //   "What's your first name?"
      // ], {defaultTextColor: "#fff"});
      return (
        <OnboardingScreenGetName
          onNameReceived={this.handleNameReceived.bind(this)}
          viewportMode={this.props.viewportMode}
        />
      );
    }
  }

  render() {
    const style = {
      fontSize: this.props.viewportMode === "portrait" ? "0.8em" : "0.5em", //mobile, desktop
      height: "100%"
    };

    const contentStyle = {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      ...this.getDesktopWrap()
    };

    const charactersContainerStyle = {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around"
    };

    const isShowingCrew =
      this.state.step === "introduce-crew" ||
      this.state.step === "outro" ||
      this.state.step === "pre-laptop-delay" ||
      this.state.step === "laptops";

    const isShowingLaptops = this.state.step === "laptops";

    return (
      <div style={{ height: "100%" }}>

        <OnboardingTransitionOverlay
          isOpaque={this.state.isOverlayOpaque}
          onTransitionComplete={this.handleOverlayDone.bind(this)}
        />

        <div style={style} className="menu-texture">
          <AudioControl />
          <div style={contentStyle}>
            <div style={charactersContainerStyle}>
              <OnboardingMemberRow
                buddiesRevealed={isShowingCrew}
                showLaptop={isShowingLaptops}
              />
            </div>

            <OnboardingLaptopContainer isLowered={this.state.isLaptopLowered}>
              {this.renderContent()}
            </OnboardingLaptopContainer>
          </div>
          {this.renderNameModal()}
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    viewportMode: state.global.viewportMode,
    isInvitedByFriend: state.battle.isMultiplayerMode //They mean the same thing here
  };
})(OnboardingScreen);



// WEBPACK FOOTER //
// ./src/b5-onboarding/OnboardingScreen.js